"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._getStackTrace = exports._safeStringify = void 0;
function _truncateString(str, maxLength) {
    if (str.length <= maxLength) {
        return str;
    }
    return str.slice(0, maxLength) + '...';
}
function _safeStringify(val, maxKeysCount, maxDepth, maxLength) {
    try {
        if (_shouldNotStringify(val, maxKeysCount, maxDepth)) {
            return _simpleStringify(val, maxLength);
        }
        if (typeof val === 'string') {
            return _truncateString(val, maxLength);
        }
        if (typeof val === 'object' && val !== null) {
            return _truncateString(JSON.stringify(val), maxLength);
        }
        return _truncateString(String(val), maxLength);
    }
    catch (_a) {
        return _truncateString('[Unserializable]', maxLength);
    }
}
exports._safeStringify = _safeStringify;
function _getStackTrace() {
    var _a, _b;
    try {
        return (_b = (_a = new Error().stack) === null || _a === void 0 ? void 0 : _a.split('\n').slice(2)) !== null && _b !== void 0 ? _b : [];
    }
    catch (_c) {
        return [];
    }
}
exports._getStackTrace = _getStackTrace;
function _shouldNotStringify(val, maxKeysCount, maxDepth) {
    if (_isPlainObject(val)) {
        if (Object.keys(val).length > maxKeysCount) {
            return true;
        }
        if (_isObjectTooDeep(val, maxDepth)) {
            return true;
        }
    }
    if (typeof val === 'function') {
        return true;
    }
    return false;
}
function _isPlainObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
function _isObjectTooDeep(obj, maxDepth) {
    if (maxDepth <= 0) {
        return true;
    }
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    return Object.keys(obj).some((key) => _isObjectTooDeep(obj[key], maxDepth - 1));
}
function _simpleStringify(val, maxLength) {
    return _truncateString(val.toString(), maxLength);
}
